import { IThemeFont } from '@/types'
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export class ThemeHandler extends Vue {
  @Getter themeFont!: IThemeFont

  $themeInsertFont () {
    const style = document.createElement('link')
    style.rel = 'stylesheet'
    style.href = this.$themeFontLink

    document.head.appendChild(style)
  }

  get $themeFontFamily () {
    switch (this.themeFont) {
      case IThemeFont.PT_MONO: {
        return '"PT Mono", monospace'
      }
      case IThemeFont.POPPINS: {
        return '"Poppins", sans-serif'
      }
      case IThemeFont.MERRIWEATHER: {
        return '"Merriweather", serif'
      }
      case IThemeFont.CORMORANT: {
        return '"Cormorant", serif'
      }
      case IThemeFont.ALEGREYA: {
        return '"Alegreya", serif'
      }
      case IThemeFont.PLAYFAIR_DISPLAY: {
        return '"Playfair Display", serif'
      }
      case IThemeFont.ANTON: {
        return '"Anton", sans-serif'
      }
      case IThemeFont.BALOO_2: {
        return '"Baloo 2", cursive'
      }
      case IThemeFont.DANCING_SCRIPT: {
        return '"Dancing Script", cursive'
      }
      case IThemeFont.SPECIAL_ELITE: {
        return '"Special Elite", cursive'
      }
      default: {
        return ''
      }
    }
  }

  get $themeFontLink (): string {
    switch (this.themeFont) {
      case IThemeFont.POPPINS: {
        return 'https://fonts-googleapis-com.universal-music.de/css?family=Poppins:400,600,700&display=swap'
      }
      case IThemeFont.MERRIWEATHER: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=Merriweather:wght@300;400;900&display=swap'
      }
      case IThemeFont.PT_MONO: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=PT+Mono&display=swap'
      }
      case IThemeFont.CORMORANT: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=Cormorant:wght@300;400;500;600;700&display=swap'
      }
      case IThemeFont.ALEGREYA: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=Alegreya:wght@400;500;600;700&display=swap'
      }
      case IThemeFont.PLAYFAIR_DISPLAY: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=Playfair+Display:wght@400;500;600;700&display=swap'
      }
      case IThemeFont.ANTON: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=Anton&display=swap'
      }
      case IThemeFont.BALOO_2: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=Baloo+2:wght@400;500;600;700&display=swap'
      }
      case IThemeFont.DANCING_SCRIPT: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=Dancing+Script:wght@400;500;600;700&display=swap'
      }
      case IThemeFont.SPECIAL_ELITE: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=Special+Elite&display=swap'
      }
      default: {
        return ''
      }
    }
  }
}
